import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-smalldw-r",
  "use": "icon-smalldw-r-usage",
  "viewBox": "0 0 10 13",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 13\" id=\"icon-smalldw-r\">\r\n  <defs>\r\n    <style>\r\n      #icon-smalldw-r .cls-1 {\r\n        fill: #e33aa3;\r\n        fill-rule: evenodd;\r\n      }\r\n    </style>\r\n  </defs>\r\n  <path id=\"icon-smalldw-r_形状_4_拷贝_2\" data-name=\"形状 4 拷贝 2\" class=\"cls-1\" d=\"M1210,739a4.98,4.98,0,0,1,5,4.958c0,1.974-2.6,5.909-4.05,7.605a1.251,1.251,0,0,1-1.9,0c-1.45-1.7-4.05-5.631-4.05-7.605a4.98,4.98,0,0,1,5-4.958h0Zm0.24,11.963c1.56-1.825,3.82-5.462,3.82-7a4.06,4.06,0,0,0-8.12,0c0,1.543,2.26,5.18,3.82,7a0.319,0.319,0,0,0,.48,0h0Zm-0.24-9.472a2.194,2.194,0,0,1,1.9,1.081,2.159,2.159,0,0,1,0,2.17,2.195,2.195,0,0,1-1.9,1.082,2.167,2.167,0,1,1,0-4.333h0Zm0,3.4a1.238,1.238,0,1,0-1.25-1.238A1.245,1.245,0,0,0,1210,744.9h0Zm0,0\" transform=\"translate(-1205 -739)\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/smalldw-r.svg
// module id = Ocw3
// module chunks = 127